export default "__VITE_ASSET__DalEFjay__"